'use client';

import { c as _c } from "react/compiler-runtime";
import { CountdownInjector } from './countdownInjector';
export interface ClientFeatures {
  countdown?: {
    targetDate: string;
  };
}
interface ClientFeaturesInjectorProps {
  features?: ClientFeatures;
}
export const ClientFeaturesInjector: React.FC<ClientFeaturesInjectorProps> = t0 => {
  const $ = _c(4);
  const {
    features
  } = t0;
  let t1;
  if ($[0] !== features) {
    t1 = features?.countdown?.targetDate && <CountdownInjector targetDateUTC={features.countdown.targetDate} />;
    $[0] = features;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};